<template>
  <div>
    <v-row>
      <v-col cols="12" class="ml-2 mt-5">
        <v-avatar
          size="100"
          v-if="society && society.logo_url != null"
          class="cursor-pointer ml-3"
        >
          <v-img
            :src="API_BASE_URL + '/uploads/' + society.logo_url"
            :alt="society.name"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-avatar>
        <v-avatar
          v-else
          color="primary"
          class="white--text cursor-pointer ml-3"
          size="100"
        >
          <span class="fontsize-11">{{ society.name.charAt(0) }}</span>
        </v-avatar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.residentType") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{ residentType(society.type) }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.societyCode") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{ society.society_code }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.name") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{ society.name }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.address") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{
              `${society.address} , ${society.city}, ${society.state}, ${society.country}`
            }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.latitude") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{ society.latitude }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.longitude") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{ society.longitude }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.noOfHouse") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{ society.no_of_house }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.noOfShop") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{ society.no_of_shop }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.currency") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{ society.currency }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-divider
        vertical
        class="d-none d-lg-flex d-md-flex d-lg-none"
      ></v-divider>
      <v-col cols="12" sm="12" md="6">
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.contactPersonName") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{ society.contact_person_name }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.contactPersonNumber") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{
              "+" + society.country_code + " " + society.contact_person_number
            }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="5" md="5" lg="5">
            <span class="font-weight-bold"
              >{{ $t("society.list.basicDetails.contactPersonEmail") }} :
            </span>
          </v-col>
          <v-col cols="6" sm="7" md="7" lg="7">
            <span>{{
              society.contact_person_email
                ? society.contact_person_email
                : "N/A"
            }}</span>
          </v-col>
        </v-row>
        <br />

        <v-row v-if="this.currentPlan.expiration_date">
          <v-col cols="12">
            <h2>Subscription Details</h2>
            <br />

            <v-row>
              <v-col cols="6" class="colum-padding">
                <label class="font-weight-bold">Current Plan:</label>
                <p>{{ currentPlan?.plan?.title }} Plan</p>
              </v-col>
              <v-col cols="6" class="colum-padding">
                <label class="font-weight-bold">Expiry Date:</label>
                <p>{{ formattedExpirationDate }}</p>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="currentPlan.expiration_date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedExpirationDate"
                      label="Expiry Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      id="ExpiryDate"
                      name="ExpiryDate"
                      clearable
                     
                    ></v-text-field>
                    
                  </template>
                  <v-date-picker
                    v-model="currentPlan.expiration_date"
                    no-title
                    :min="minDate"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(currentPlan.expiration_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <v-btn
                  color="secondary"
                  dark
                  @click="updateDateChange(currentPlan.expiration_date)"
                  >update</v-btn
                >
              </v-col>
            </v-row>

            <v-dialog v-model="dialogDate" max-width="450" persistent>
              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  Confirm!!
                </v-card-title>
                <v-card-text class="mt-2"
                  >Are you sure that you want to extend the plan until
                  {{ getFormattedDate(newSelectedDate) }}?</v-card-text
                >

                <v-card-actions class="justify-end">
                  <v-btn
                    color="primary"
                    text
                    @click="extendDate"
                    class="delete-btn"
                  >
                    yes</v-btn
                  >
                  <v-btn color="primary" text @click="closeDelete">no</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: {
    society_id: String,
  },
  data() {
    return {
      society: {
        name: "",
      },
      newSelectedDate: null,
      currentPlan: {
        expiration_date: null,
      },
      menu: false,
      dialogDate: false,


      residentTypes: [
        {
          id: 1,
          name: "Residential",
        },
        {
          id: 2,
          name: "Commercial",
        },
        {
          id: 3,
          name: "Residential & Commercial",
        },
      ],
    };
  },
  computed: {
    formattedExpirationDate() {
      if (this.currentPlan.expiration_date) {
        const date = new Date(this.currentPlan.expiration_date);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        return `${day}-${month}-${year}`;
      } else {
        return null;
      }
    },
    minDate() {
    let minDate;
    if (this.currentPlan.expiration_date && new Date(this.currentPlan.expiration_date) < new Date()) {
      // If expiration date is in the past, set minDate to today's date
      minDate = new Date().toISOString().substr(0, 10); // Today's date in 'YYYY-MM-DD' format
    } else {
      // Use expiration date if available, otherwise empty string
      minDate = this.currentPlan.expiration_date|| "";
    }
    return minDate;
  }
   
  },
  methods: {
    formatDateForInput(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      // Ensure month and day are formatted with leading zeros if necessary
      month = month < 10 ? `0${month}` : month;
      day = day < 10 ? `0${day}` : day;

      return `${year}-${month}-${day}`;
    },

    ...mapMutations("alert", ["setAlert"]),

    updateDateChange(newDate) {
      this.newSelectedDate = newDate;
      this.dialogDate = true;
    },

    closeDelete() {
      this.dialogDate = false;
    },
    async extendDate() {
      let _self = this;
      this.dialogDate = false;
      const data = { expiration_date: this.newSelectedDate };
      console.log(data);
      _self.$axios
        .put("superadmin/society-plan/" + this.society_id, data)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.getUserPlan();
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },

    getFormattedDate(date) {
      const parsedDate = new Date(date);
      const year = parsedDate.getFullYear();
      const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
      const day = parsedDate.getDate().toString().padStart(2, "0");
      return `${day}-${month}-${year}`;
    },
    getSocietyDetails() {
      let _self = this;

      _self.$axios
        .get(`superadmin/society/${this.society_id}`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.society = data.society;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },

    getUserPlan() {
      let _self = this;
      _self.$axios
        .get(`superadmin/user-plan/${this.society_id}`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.currentPlan = data.current;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    residentType(societyType) {
      let residenttype = this.residentTypes.find(
        (type) => type.id == societyType
      );
      return residenttype ? residenttype.name : "N/A";
    },
  },
  mounted() {
    this.getSocietyDetails();
    this.getUserPlan();
  },
};
</script>

<style>
.colum-padding {
  padding: 25px;
}
</style>
